export default __webpack_public_path__ + "static/media/button-arrow.52c9c12e.svg";